import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Providers from "./providers";
import reportWebVitals from "./reportWebVitals";
import Routes from "./Routes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Providers>
      <Routes />
    </Providers>
  </React.StrictMode>
);

reportWebVitals();
